import React, { useCallback, useContext, useEffect, useState } from 'react';
import './SignIn.css';
import { useDispatch, useSelector } from 'react-redux';
import { StudentsigninRequest, TeachersigninRequest, clearMessage } from '../../actions/userActions';
import { Link, useNavigate } from 'react-router-dom';
import AuthContext from '../Navbar/AuthContext';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import GoogleLoginButton from '../signup/GoogleLoginButton';

function SignIn() {
  const signinSuccessMessage = useSelector(state => state.user.SignINSucess);
  const signinFailure = useSelector(state => state.user.SignInFailure);
  const isLoading = useSelector(state => state.user.loading);

  const [isStudentLogin, setStudentLogin] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [notification, setNotification] = useState({ show: false, type: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { login } = useContext(AuthContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const studentToggleButton = () => {
    setStudentLogin(true);
  };

  const teacherToggleButton = () => {
    setStudentLogin(false);
  };

  const handleLin = useCallback(() => {
    login();
  }, [login]);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const showCustomNotification = (type, message) => {
    setNotification({ show: true, type, message });
    setTimeout(() => {
      setNotification({ show: false, type: '', message: '' });
    }, 3000);
  };

  const handleSubmit = e => {
    e.preventDefault();
    if (isSubmitting) return;

    if (!formData.email || !formData.password) {
      showCustomNotification('warning', 'Please enter both email and password');
      return;
    }

    setIsSubmitting(true);
    if (isStudentLogin) {
      dispatch(StudentsigninRequest(formData));
    } else {
      dispatch(TeachersigninRequest(formData));
    }
  };

  useEffect(() => {
    if (signinFailure) {
      showCustomNotification('error', 'Please enter valid credentials');
      setIsSubmitting(false);
      setTimeout(() => {
        dispatch(clearMessage());
      }, 3000);
    }
  }, [signinFailure, dispatch]);

  useEffect(() => {
    if (signinSuccessMessage) {
      showCustomNotification('success', 'Login successful! Redirecting...');
      handleLin();
      setTimeout(() => {
        navigate('/');
        dispatch(clearMessage());
        setIsSubmitting(false);
      }, 2000);
    }
  }, [signinSuccessMessage, handleLin, navigate, dispatch]);

  return (
    <div className='signin-container'>
      {notification.show && (
        <div className={`custom-notification ${notification.type}`}>
          {notification.message}
        </div>
      )}

      <div className='signin-wrapper'>
        <div className="login-box">
          <div className="login-header">
            <h2>{isStudentLogin ? 'Student Login' : 'Creator Login'}</h2>
          </div>
          
          <div className="login-toggle">
            <button 
              className={`toggle-btn ${isStudentLogin ? 'active' : ''}`}
              onClick={studentToggleButton}
              type="button"
            >
              Student
            </button>
            <button 
              className={`toggle-btn ${!isStudentLogin ? 'active' : ''}`}
              onClick={teacherToggleButton}
              type="button"
            >
              Creator
            </button>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <input 
                type="email" 
                name="email" 
                value={formData.email} 
                onChange={handleChange} 
                placeholder="Enter Your Email" 
                required
                disabled={isSubmitting}
              />
            </div>
            <div className="form-group password-input">
              <input 
                type={showPassword ? "text" : "password"} 
                name="password" 
                value={formData.password} 
                onChange={handleChange} 
                placeholder="Enter Your Password" 
                required
                disabled={isSubmitting}
              />
              <span 
                className="password-toggle" 
                onClick={togglePasswordVisibility}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
            <div className="forgot-password">
              <Link to="/forgotpassword">Forgot password?</Link>
            </div>
            <button 
              type="submit" 
              className="login-button"
              disabled={isSubmitting || isLoading}
            >
              {isSubmitting || isLoading ? (
                <div className="button-loader-container">
                  <span className="button-loader"></span>
                  <span>Logging in...</span>
                </div>
              ) : (
                'Login'
              )}
            </button>    
          </form>
             {/* Google Login Button */}
            <div className="social-login-section">
              <div className="divider">
                <span>Continue with</span>
              </div>
              <GoogleLoginButton
                userType={isStudentLogin ? 'student' : 'creator'}
                disabled={isSubmitting || isLoading}
              />
            </div>
            <div className="signup-link">
              Not a member? <Link to="/signup">Signup now</Link>
            </div>
        </div>
      </div>
    </div>
  );
}

export default SignIn;